import * as ng from 'angular';

export class SelectFiltersController implements ng.IController {
   static $inject = ['filters'];

   filters = ['grayscale', 'sepia', 'warm', 'cold'];

   constructor(public selected:string[]) { }

   isSelected(filter:string) {
      return this.selected.indexOf(filter) !== -1;
   }

   onClickFilter(filter:string) {
      let i = this.selected.indexOf(filter);
      if (i !== -1) {
         this.selected.splice(i, 1);
      } else {
         this.selected.push(filter);
      }
   }
}

ng.module('e360')
   .controller('SelectFiltersController', SelectFiltersController);
